export const FETCH_CAMPAIGNS = 'campaigns/FETCH_CAMPAIGNS'
export const CREATE_CAMPAIGN = 'campaigns/CREATE_CAMPAIGN'
export const CLEAR_CAMPAIGN_INSIGHTS = 'campaigns/CLEAR_CAMPAIGN_INSIGHTS'
export const ADD_INSIGHT_TO_CAMPAIGN = 'campaigns/ADD_INSIGHT_TO_CAMPAIGN'
export const CLEAR_ADSETS_INSIGHTS = 'campaigns/CLEAR_ADSETS_INSIGHTS'
export const ADD_INSIGHT_TO_ADSET = 'campaigns/ADD_INSIGHT_TO_ADSET'
export const CLEAR_ADS_INSIGHTS = 'campaigns/CLEAR_ADS_INSIGHTS'
export const ADD_INSIGHT_TO_AD = 'campaigns/ADD_INSIGHT_TO_AD'
export const ADD_INSIGHTS_TO_CAMPAIGN = 'campaigns/ADD_INSIGHTS_TO_CAMPAIGN'
export const CLEAR_CAMPAIGNS_STATE = 'campaigns/CLEAR_CAMPAIGNS_STATE'
export const EDIT_CAMPAIGN = 'campaigns/EDIT_CAMPAIGN'
export const DELETE_CAMPAIGN = 'campaigns/DELETE_CAMPAIGN'
